import { render, staticRenderFns } from "./email-log.vue?vue&type=template&id=71d23c16&scoped=true&"
import script from "./email-log.vue?vue&type=script&lang=js&"
export * from "./email-log.vue?vue&type=script&lang=js&"
import style0 from "./email-log.vue?vue&type=style&index=0&id=71d23c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d23c16",
  null
  
)

export default component.exports